/* eslint-disable jsx-a11y/anchor-is-valid */
import { useActivation } from '@context/MobileOne';
import {
  ButtonPrimary,
  CardInfobox,
  CardSupport,
  Link,
  NavigationPageTitle,
  Ta11yText,
  ScrollToTop,
  ButtonCancelActivation
} from '@core/index';
import Icons from '@core/Utils/Icons/Icons';
import { useStaticContent } from '@dom-digital-online-media/dom-static-content-sdk';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import {
  appButtonType,
  appCardStyle,
  appIconsPath,
  appInfoCardSize,
  appLinkSize,
  appLinkStyle
} from '@utils/globalConstant';
import moment from 'moment';
import React from 'react';

export function OverviewData() {
  // Contexts
  const {
    isLoading,
    setStep8SubStep,
    countries,
    simProvider,
    withMNP,
    tariffActivationForm,
    phoneNumberActivationForm,
    personalDataForm,
    legitimationMethods,
    getTariffName
  } = useActivation();
  const { staticContentData } = useStaticContent();
  
  // const
  const overviewHeader2Content = tA11y('ek_reg_summary_hdl2');
  const overviewHeader3Content = tA11y('ek_reg_summary_hdl3');
  const overviewHeader4Content = tA11y('ek_reg_summary_hdl4');
  const overviewHeader5Content = tA11y('ek_reg_summary_hdl5');
  const overviewHeader6Content = tA11y('ek_reg_summary_hdl6');
  const overviewHeader7Content = tA11y('ek_reg_summary_hdl7');
  const overviewText7Content = tA11y('ek_reg_summary_txt1');
  const overviewbtnContent = tA11y('ek_reg_summary_btn1');
  // TODO make changes with Legitimation process to show or hide the section
  const isLegitimationShow = false;

  // Function
  const handleSubmit = () => {
    setStep8SubStep(1);
  };

  // const
  const LegitimationCopyTextContent = replaceDynamicCmsContent(
    tA11y('ek_reg_summary_change_txt1'),
    '{LEGITIMATION_NAME}',
    `${personalDataForm.legitimationName}`
  );
  
  const getSpeedName = (tariffId) => {
    const tariff = staticContentData?.ek_tariff?.find((t) => t.id === tariffId);
    return tariff ? tariff.nameSpeed : '';
  }

  const tariffName = getTariffName(tariffActivationForm?.chosenTariffName, getSpeedName(tariffActivationForm?.chosenTariffId));
  
  return (
    <>
      <ScrollToTop>
        <section className="min-dvh-100 overview-data-container">
          <AppPageContentWrapper>
            <div className="w-100 pb-40">
              <NavigationPageTitle headingTag='h2' title="ek_reg_summary_hdl1" variant="sm" />
            </div>
            {/* Tarrif Data */}
            <div className="details-container">
              <div className="title-container d-flex align-items-center text-primary">
                <Icons name='USER_SHILD' width={24} height={24} colorType='dark'/>
                <Ta11yText
                  tag="h3"
                  textContent={overviewHeader2Content}
                  className="ek-h3 m-0 px-3"
                />
              </div>
              <div className="details-text pt-20">
                <Ta11yText
                  tag="p"
                  textContent={tariffName}
                  className="ek-copy-16-regular"
                />
              </div>
              <span className="w-100 border-bottom border-secondary d-flex my-40" />
            </div>
            {/* MNP Data */}
            {withMNP && (
              <div className="details-container">
                <div className="title-container d-flex align-items-center text-primary">
                  <Icons name='USER_SHILD' width={24} height={24} colorType='dark'/>
                  <Ta11yText
                    tag="h3"
                    textContent={overviewHeader7Content}
                    className="ek-h3 m-0 px-3"
                  />
                </div>
                <div className="details-text pt-20">
                  <Ta11yText
                    tag="p"
                    textContent={overviewText7Content}
                    className="ek-copy-16-regular m-0"
                  />
                  <p className="ek-copy-16-regular">{`${phoneNumberActivationForm.oldNumberPrefix} ${phoneNumberActivationForm.oldNumber}`}</p>
                  <p className="ek-copy-16-regular">
                    {
                      simProvider.find(
                        (provider) => phoneNumberActivationForm.currentProvider === provider.id
                      )?.value
                    }
                  </p>
                </div>
                <Link
                  // label={overviewEditLink1Content?.content}
                  label="ek_reg_summary_change_lnk4"
                  iconLeft={appIconsPath.EDIT}
                  linkStyle={`${appLinkStyle.PRIMARY} mt-20`}
                  linkSize={appLinkSize.DEFAULT}
                  onClick={() => setStep8SubStep(5)}
                />
                <span className="w-100 border-bottom border-secondary d-flex my-40" />
              </div>
            )}
            {/* Personal Data */}
            <div className="details-container">
              <div className="title-container d-flex align-items-center text-primary">
                <Icons name='USER_SHILD' width={24} height={24} colorType='dark'/>
                <Ta11yText
                  tag="h3"
                  textContent={overviewHeader3Content}
                  className="ek-h3 m-0 px-3"
                />
              </div>
              <div className="details-text pt-20">
                <p className="ek-copy-16-regular mb-8">{personalDataForm.firstName}</p>
                <p className="ek-copy-16-regular mb-8">{personalDataForm.lastName}</p>
                <p className="ek-copy-16-regular">
                  {moment(personalDataForm.birthDate, 'DD.MM.YYYY').format('DD/MM/YYYY')}
                </p>
              </div>
              <div className="title-container d-flex align-items-center text-primary">
                <Link
                  // label={overviewEditLink1Content?.content}
                  label="ek_reg_summary_change_lnk1"
                  iconLeft={appIconsPath.EDIT}
                  linkStyle={`${appLinkStyle.PRIMARY} mt-20`}
                  linkSize={appLinkSize.DEFAULT}
                  onClick={() => setStep8SubStep(6)}
                />
              </div>
              <span className="w-100 border-bottom border-secondary d-flex my-40" />
            </div>
            {/* Address Data */}
            <div className="details-container">
              <div className="title-container d-flex align-items-center text-primary">
                <Icons name='MARKER1' width={24} height={24} colorType='dark'/>
                <Ta11yText
                  tag="h3"
                  textContent={overviewHeader4Content}
                  className="ek-h3 m-0 px-3"
                />
              </div>
              <div className="details-text pt-20">
                <p className="ek-copy-16-regular mb-8">{personalDataForm.street}</p>
                <p className="ek-copy-16-regular mb-8">{personalDataForm.houseNumber}</p>
                <p className="ek-copy-16-regular mb-8">{personalDataForm.zip}</p>
                <p className="ek-copy-16-regular mb-8">{personalDataForm.city}</p>
                <p className="ek-copy-16-regular">
                  {countries?.find((contry) => personalDataForm.countryCode === contry.id)?.value}
                </p>
              </div>
              <div className="title-container d-flex align-items-center text-primary">
                <Link
                  // label={overviewEditLink1Content?.content}
                  label="ek_reg_summary_change_lnk2"
                  iconLeft={appIconsPath.EDIT}
                  linkStyle={`${appLinkStyle.PRIMARY} mt-20`}
                  linkSize={appLinkSize.DEFAULT}
                  onClick={() => setStep8SubStep(7)}
                />
              </div>
              <span className="w-100 border-bottom border-secondary d-flex my-40" />
            </div>
            {/* Legitimation Data */}
            {legitimationMethods.length > 1 && (
              <div className="details-container">
                <div className="title-container d-flex align-items-center text-primary">
                  <Icons name='USER_SHILD' width={24} height={24} colorType='dark'/>
                  <Ta11yText
                    tag="h3"
                    textContent={overviewHeader5Content}
                    className="ek-h3 m-0 px-3"
                  />
                </div>
                <div className="details-text pt-20">
                  <Ta11yText
                    tag="p"
                    textContent={LegitimationCopyTextContent}
                    className="ek-copy-16-regular"
                  />
                </div>
                <div className="title-container d-flex align-items-center text-primary">
                  <Link
                    // label={overviewEditLink1Content?.content}
                    label="ek_reg_summary_change_lnk3"
                    iconLeft={appIconsPath.EDIT}
                    linkStyle={`${appLinkStyle.PRIMARY} mt-20`}
                    linkSize={appLinkSize.DEFAULT}
                    onClick={() => setStep8SubStep(8)}
                  />
                </div>
                <span className="w-100 border-bottom border-secondary d-flex my-40" />
              </div>
            )}
            {/* Email Section */}
            <div className="details-container">
              <div className="title-container d-flex align-items-center text-primary">
                <Icons name='ENVELOPE' width={24} height={24} colorType='dark'/>
                <Ta11yText
                  tag="h3"
                  textContent={overviewHeader6Content}
                  className="ek-h3 m-0 px-3"
                />
              </div>
              <div className="details-text pt-20">
                <p className="ek-copy-16-regular">{phoneNumberActivationForm.email}</p>
              </div>
              <div className="details-text pt-20 w-100">
                <CardInfobox
                  cardStyle={appCardStyle.SECONDARY}
                  cardSize={appInfoCardSize.DEFAULT}
                  cardIcon={appIconsPath.INFO}
                  text="ek_reg_summary_info_txt1"
                />
              </div>
              <span className="w-100 border-bottom border-secondary d-flex my-40" />
            </div>
            <div className="w-100 d-flex justify-content-center">
              <div className="col-xxl-5 col-lg-5 col-10 px-0">
                <ButtonPrimary
                  buttonType={appButtonType.PRIMARY}
                  buttonContent={overviewbtnContent}
                  onClick={handleSubmit}
                  isLoading={isLoading}
                />
              </div>
            </div>
            <div className="space-40" />
            <CardSupport />
            <div className="d-flex justify-content-center mt-32">
              <ButtonCancelActivation />
            </div>
          </AppPageContentWrapper>
        </section>
      </ScrollToTop>
    </>
  );
}

export default OverviewData;
